import { makeStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { COLORS } from 'src/utils/Themes/colors'
import InfoIcon from '@mui/icons-material/Info'
import {
  addScroll,
  getUrlLastRoute,
  removeScroll,
} from 'src/utils/commonMethods'
import Button from '@mui/material/Button'
import { useEffect, useState } from 'react'
import {
  getInsuranceDetails,
  getProviderDetails,
} from 'src/services/buyPolicyService'
import LoadingModal from 'src/components/common/LoadingModal'
import { FormControl, MenuItem, Select } from '@mui/material'
import { getTokenForQrReport } from 'src/services/individualService'
import {
  showNotificationMessage,
  updatePolicyTenurePeriod,
  updateProviderDetails,
  updateSelectedQuote,
} from 'src/actions'
import { clearAndDispatchMemberDetails } from 'src/utils/commonMethods/buyPolicy'
import { useHistory } from 'react-router-dom'
import {
  HEALTH_ROUTES,
  POLICY_TENURE_LIST,
} from 'src/utils/constants/BuyPolicy'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { ENCOUNTERED_ERROR_POCILY_DETAILS } from 'src/utils/constants/Health'

const PriceDetails = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()
  const urlLastRoute = getUrlLastRoute()
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const selectedQuote = guestUserDetails?.selectedQuote
  const fullQuote = guestUserDetails?.selectedFullQuote
  const [policyTenurePeriod, setPolicyTenurePeriod] = useState(
    selectedQuote?.policyTenure || guestUserDetails?.policyTenurePeriod
  )
  const quoteDetails = fullQuote ?? selectedQuote
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!isTermsAndConditions() && isValidState()) {
      fetchToken()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guestUserDetails?.userDetails, policyTenurePeriod])

  useEffect(() => {
    setPolicyTenurePeriod(guestUserDetails?.policyTenurePeriod)
  }, [guestUserDetails?.policyTenurePeriod])

  const fetchInsuranceDetailsManual = async (token) => {
    setLoading(true)

    const formData = {
      ...guestUserDetails?.userDetails,
      sumInsured: Number(selectedQuote?.sumInsured),
      policyPeriod: Number(policyTenurePeriod),
      membersInfo: [...guestUserDetails?.memberDetails],
      providerId: selectedQuote?.providerId,
      insuranceId: selectedQuote?.insuranceId,
    }

    const response = await getInsuranceDetails(token, formData)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        if (responseData?.quoteDetails?.length) {
          dispatch(updateSelectedQuote(responseData?.quoteDetails?.[0]))
        }
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ENCOUNTERED_ERROR_POCILY_DETAILS,
        })
      )
    }
  }

  const fetchProviderDetails = async (token) => {
    setLoading(true)

    const response = await getProviderDetails(token, quoteDetails?.providerId)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        dispatch(updateProviderDetails(responseData?.data))
        dispatchAndRedirect()
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  const fetchToken = async (isFetchProviderDetails = false) => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      if (isFetchProviderDetails) {
        fetchProviderDetails(token)
      } else {
        fetchInsuranceDetailsManual(token)
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
        })
      )
    }
  }

  const showUpdatedText = () => {
    return quoteDetails?.premiumAmount !== selectedQuote?.premiumAmount
  }

  const showProceedButton = () => {
    const urlLastRoute = getUrlLastRoute()
    return urlLastRoute === HEALTH_ROUTES?.planDetails
  }

  const dispatchAndRedirect = () => {
    dispatch(updateSelectedQuote(quoteDetails))
    history.push(
      '/individual/dashboard/buyPolicy/health/insuranceDetails/member-details'
    )
  }

  const handleProceed = () => {
    clearAndDispatchMemberDetails(guestUserDetails, dispatch)
    fetchToken(true)
  }

  const updatePolicyTenure = (event) => {
    setPolicyTenurePeriod(event?.target?.value)
    dispatch(updatePolicyTenurePeriod(event?.target?.value))
  }

  const isTermsAndConditions = () => {
    return urlLastRoute?.includes(HEALTH_ROUTES?.termsAndConditions)
  }

  const isValidState = () => {
    return !!guestUserDetails?.userDetails?.fullName
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.mainContainer}>
        <div className={classes.quoteContainer}>
          <div className={classes.quoteSection}>
            <div>
              <img
                src={quoteDetails?.providerImage}
                alt='providerImage'
                className={classes.digitImage}
              />
              <div>
                <span className={classes.digitInput}>
                  {quoteDetails?.providerName}
                </span>
              </div>
            </div>
            <div>
              <span className={classes.digitOtherInput}>
                {quoteDetails?.insuranceName}
              </span>
              <span className={classes.digitCoverRate}>
                Cover:&nbsp;&nbsp;<b>{formatToINR(quoteDetails?.sumInsured)}</b>
              </span>
            </div>
          </div>
          <div className={classes.quoteSection}>
            <span className={classes.digitBaseInput}>
              {isTermsAndConditions() ? (
                <span>
                  Base Premium - {policyTenurePeriod} Year
                  {policyTenurePeriod > 1 ? 's' : ''}
                </span>
              ) : (
                <div className={classes.tenureSelectContainer}>
                  <span>Base Premium - </span>
                  <FormControl size='small'>
                    <Select
                      id='SelectControl'
                      value={policyTenurePeriod}
                      onChange={updatePolicyTenure}
                      displayEmpty
                      className={classes.selectControl}
                      onOpen={() => {
                        removeScroll()
                      }}
                      onClose={() => {
                        addScroll()
                      }}
                    >
                      {POLICY_TENURE_LIST?.map((policyTenureListItem) => {
                        return (
                          <MenuItem
                            value={policyTenureListItem?.value}
                            key={`policyTenureListItem_${policyTenureListItem?.value}`}
                          >
                            {policyTenureListItem?.label}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                </div>
              )}
            </span>
            <span className={classes.digitRate}>
              {formatToINR(
                quoteDetails?.basePremiumAmount ?? quoteDetails?.premiumAmount
              )}
            </span>
          </div>
          {quoteDetails?.discountAmount ? (
            <div className={classes.quoteSection}>
              <span className={classes.digitBaseInput}>Discount</span>
              <span className={classes.digitRate}>
                -&nbsp;{formatToINR(quoteDetails?.discountAmount)}
              </span>
            </div>
          ) : null}

          {quoteDetails?.totalTaxAmount ? (
            <div className={classes.quoteSection}>
              <span className={classes.digitBaseInput}>Tax</span>
              <span className={classes.digitRate}>
                {formatToINR(quoteDetails?.totalTaxAmount)}
              </span>
            </div>
          ) : null}
        </div>
        <div className={classes.totalPremium}>
          <span className={classes.premiuSubTitle}>Total Premium </span>
          <span className={classes.premiuSubTitle}>
            {formatToINR(quoteDetails?.premiumAmount)}
          </span>
        </div>
        {showUpdatedText() && (
          <span className={classes.updatedText}>
            <InfoIcon />
            Please note that quote details have been updated
          </span>
        )}
        {showProceedButton() ? (
          <div className={classes.proceedButtonContainer}>
            <Button
              id='proceedButton'
              variant='contained'
              className={classes.proceedButton}
              onClick={handleProceed}
            >
              Proceed
            </Button>
          </div>
        ) : null}
      </div>
    </>
  )
}

export default PriceDetails

const useStyles = makeStyles({
  mainContainer: {
    border: '1px',
    background: 'linear-gradient( #EF669B -900%, #FFFFFF 100%)',
    boxShadow: '0px 4px 4px 0px #00000040',
    padding: '30px 20px',
    borderRadius: '10px',
  },
  digitItems: {
    marginLeft: '11px',
    marginBottom: '20px',
  },
  digitImage: {
    width: '60px',
    marginBottom: '-5px',
  },
  digitInput: {
    fontFamily: 'Roboto',
    fontSize: '10px',
    color: '#666666 ',
  },
  digitBaseInput: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    whiteSpace: 'nowrap',
  },

  digitOtherInput: {
    fontFamily: 'Roboto',
    fontSize: '17px',
    display: 'flex',
    color: '#2BA6C8',
    flexDirection: 'row-reverse',
    fontWeight: '600',
  },
  digitCoverRate: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    // fontWeight:'600',
  },
  digitInputRate: {
    marginBottom: '28px',
    marginLeft: '105px',
  },
  selectControl: {
    '&  .MuiInputBase-root': {
      height: '50px !important',
      minHeight: 'unset',
    },
    '&  .MuiSelect-select': {
      height: '20px !important',
    },
  },
  digitRate: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  totalPremium: {
    display: 'flex',
    border: '1px solid #EF669B',
    padding: '10px 20px',
    borderRadius: '10px',
    backgroundColor: 'white',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  premiuSubTitle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  premiumRate: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    marginLeft: '142px',
  },
  quoteSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '10px',
    alignItems: 'center',
  },
  updatedText: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    gap: '5px',
    fontSize: '14px',
    opacity: '0.8',
    color: COLORS.DARK_PINK,
  },
  quoteContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '0px 20px',
  },
  proceedButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
  },
  proceedButton: {
    backgroundColor: '#EF669B !important',
    height: '35px',
    width: '125px',
    borderRadius: '10px !important',
    fontSize: '14px !important',
    '&:hover': {
      backgroundColor: '#EF669B !important',
    },
  },
  tenureSelectContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})
